import { API_URLS } from "../constants";
import { postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { API_KEY } = API_URLS;

const getBrandConfiguration = (body) => {
  return postRequest(API_KEY.ALL, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response),
  );
};

const manageBrandConfiguration = (payload) => {
  return postRequest(API_KEY.GENERATE, payload).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response),
  );
};

//Exporting functions for other files
export const brandConfigurationService = {
  getBrandConfiguration,
  manageBrandConfiguration,
};
